import Vue from 'vue'

export function makeLogger (prefix, injectedLog) {
  return function log (...args) {
    if (injectedLog && typeof injectedLog === 'function') {
      try {
        injectedLog(prefix, ...args)
      } catch {
        // ignore
      }
      return
    }

    try {
      // eslint-disable-next-line no-console
      console.log(prefix, ...args)
    } catch {
      // ignore
    }
  }
}

export const loggerMixin = Vue.extend({
  methods: {
    _initLogger (prefix) {
      const vm = this as any
      vm._logger = makeLogger(prefix, (vm.$root && vm.$root.$log) || null)
    },
    _log (...args) {
      const vm = this as any

      if (typeof vm._logger !== 'function') {
        return
      }

      vm._logger(...args)
    }
  }
})
